import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'
import dict from './modules/dict'
import sysConfig from './modules/sysConfig'
import stateInfo from './modules/stateInfo'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    dict,
    sysConfig,
    stateInfo
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js